<template>
  <div class="compressed-content">
    <h3>Have you had Type 1 diabetes for more than 20 years?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.hadDiabetesType1">
      <b-form-radio v-model="survey.bloodSugar.diabetesHistory.hadDiabetesType1" name="hadDiabetesType1" 
                    :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.bloodSugar.diabetesHistory.hadDiabetesType1" name="hadDiabetesType1" 
                    :value="false">No</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { required } from "vuelidate/lib/validators";

  export default {
    mixins: [formMixin],

    validations: {
      hadDiabetesType1: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      hadDiabetesType1() { return this.survey.bloodSugar.diabetesHistory.hadDiabetesType1; }
    }
  };
</script>